import { render, staticRenderFns } from "./UsersCustomer.vue?vue&type=template&id=73835fc2&scoped=true&"
import script from "./UsersCustomer.vue?vue&type=script&lang=js&"
export * from "./UsersCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73835fc2",
  null
  
)

export default component.exports